import { cn } from '@/lib/utils'
import type { ServiceConnectionIcon } from '../registry'

interface Props {
  icon: ServiceConnectionIcon
  className?: string
}

/** Renders a type's hardcoded icon — a lucide glyph or a brand asset. */
export function ServiceConnectionTypeIcon({ icon, className }: Props) {
  if (icon.kind === 'image') {
    return <img src={icon.src} alt="" className={cn('size-4 object-contain', className)} />
  }

  const Icon = icon.icon
  return <Icon className={cn('size-4', className)} />
}
